export enum ReservationsTabsEnums {
  reservations = 'reservations',
  boughtGifts = 'boughtGifts',
  forDeliveries = 'forDeliveries'
}
